var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoBookedCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 430.63 278.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #f58989;\n      }\n\n      .cls-2, .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        opacity: .9;\n      }\n\n      .cls-3 {\n        opacity: 0;\n      }\n\n      .cls-5 {\n        fill: #fccbac;\n      }\n\n      .cls-6 {\n        fill: #efa278;\n      }\n\n      .cls-7 {\n        fill: #f4f2e4;\n      }\n\n      .cls-8 {\n        fill: #d7e9ec;\n        isolation: isolate;\n        opacity: .59;\n      }\n\n      .cls-9 {\n        fill: #e85d5d;\n      }\n\n      .cls-10 {\n        fill: #bf672c;\n      }\n\n      .cls-11 {\n        fill: #161616;\n      }\n\n      .cls-12 {\n        fill: #eac9c5;\n      }\n\n      .cls-13 {\n        opacity: .2;\n      }\n\n      .cls-14 {\n        fill: #fee9e6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CakeBooked"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    id: "cakeShadow",
    className: "cls-8",
    cx: 215.24,
    cy: 238.97,
    rx: 128,
    ry: 34
  }), /*#__PURE__*/React.createElement("g", {
    id: "cake_notbooked",
    "data-name": "cake notbooked"
  }, /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_571",
    "data-name": "Group 571"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_570",
    "data-name": "Group 570"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_569",
    "data-name": "Group 569"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_560",
    "data-name": "Group 560"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_826",
    "data-name": "Path 826",
    className: "cls-5",
    d: "m112.59,204.42v36.1h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-36.1H112.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_827",
    "data-name": "Path 827",
    className: "cls-10",
    d: "m215.49,258.22c-56.7,0-102.8-9.6-102.9-21.5h0v3.8h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-3.8h0c-.2,11.9-46.2,21.5-102.9,21.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_828",
    "data-name": "Path 828",
    className: "cls-1",
    d: "m112.59,176.32v36.1h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-36.1H112.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_829",
    "data-name": "Path 829",
    className: "cls-7",
    d: "m112.59,160.62v27.9h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-27.9H112.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_830",
    "data-name": "Path 830",
    className: "cls-2",
    d: "m323.69,213.82c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-18.4-7-52.3-11.7-91-11.7s-75.4,5.1-93.2,12.6c-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.6,6.4,6.5,6.7,6.5,6.7v-37.3c0-3.5,2-6.9,5.3-7.9,1.07-.33,2.21-.37,3.3-.1,4.7,1.3,9.5,4.2,10.1,9.9.6,5.6-1.8,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.7,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.93-4.34-1.47-8.76-1.6-13.2,0-5.2.3-11.4,1.5-14.9,1.34-4.26,5.88-6.63,10.14-5.3.85.27,1.65.67,2.36,1.2,3.1,2.5,3.3,14.2,12.2,13.3s4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9s-2.2,11.3,3.7,10.8c4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9s7.7-4.4,9.1.3,4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2-2.3-5.6-2.8-8.7-2.8-11.6,0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4-1.4-5.2-.8-23.9,1.4-24.9,9.1-4.2,5.2,17.4,14.1,14.5,4.8-1.5,4.9-10.7,6.9-17.5,1.6-5.3,4.9-2.2,4.9-.6l.3,34c2.76-.26,5.09-2.15,5.9-4.8.61-1.86.43-3.88-.5-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_831",
    "data-name": "Path 831",
    className: "cls-2",
    d: "m112.59,177.52v49.7c.6.29,1.24.49,1.9.6v-37.3c0-3.5,2-6.9,5.3-7.9,1.07-.33,2.21-.37,3.3-.1,4.7,1.3,9.5,4.2,10.1,9.9.6,5.6-1.9,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.8,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.93-4.34-1.47-8.76-1.6-13.2,0-5.2.3-11.4,1.5-14.9,1.34-4.26,5.88-6.63,10.14-5.3.85.27,1.65.67,2.36,1.2,3.1,2.5,3.3,14.2,12.2,13.3s4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9s-2.2,11.3,3.7,10.8c4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9s7.7-4.4,9.1.3,4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2-2.3-5.6-2.8-8.7-2.8-11.6,0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4-1.4-5.2-.8-23.9,1.4-24.9,9.1-4.2,5.2,17.4,14.1,14.6,4.8-1.5,4.9-10.7,6.9-17.5.9-3.2,2.5-3.3,3.6-2.6v-29.4H112.59v16.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_832",
    "data-name": "Path 832",
    className: "cls-9",
    d: "m172.89,216.62c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3,1.48,3.3,3.3,3.3h0c1.82-.02,3.28-1.48,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_833",
    "data-name": "Path 833",
    className: "cls-9",
    d: "m192.59,225.02c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8c.03,1.53,1.27,2.77,2.8,2.8,1.55,0,2.8-1.25,2.8-2.8h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_44",
    "data-name": "Ellipse 44",
    className: "cls-9",
    cx: 221.19,
    cy: 220.82,
    r: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_834",
    "data-name": "Path 834",
    className: "cls-9",
    d: "m139.09,220.82c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.26-.01,2.29-1.04,2.3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_835",
    "data-name": "Path 835",
    className: "cls-6",
    d: "m164.89,247.52c0-1.05-.85-1.9-1.9-1.9-1.05,0-1.9.85-1.9,1.9,0,1.05.85,1.9,1.9,1.9h0c1.05,0,1.9-.85,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_836",
    "data-name": "Path 836",
    className: "cls-6",
    d: "m186.49,244.72c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8c.03,1.53,1.27,2.77,2.8,2.8,1.55,0,2.8-1.25,2.8-2.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_837",
    "data-name": "Path 837",
    className: "cls-6",
    d: "m212.29,255.52c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8,1.25,2.8,2.8,2.8h0c1.55,0,2.8-1.25,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_838",
    "data-name": "Path 838",
    className: "cls-6",
    d: "m125.89,241.42c0-1.05-.85-1.9-1.9-1.9-1.05,0-1.9.85-1.9,1.9,0,1.05.85,1.9,1.9,1.9h0c1.02.03,1.87-.76,1.9-1.78,0-.04,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_839",
    "data-name": "Path 839",
    className: "cls-6",
    d: "m251.69,245.72c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.25.02,2.28-.98,2.3-2.23,0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_840",
    "data-name": "Path 840",
    className: "cls-6",
    d: "m305.69,236.32c0-1.55-1.25-2.8-2.8-2.8s-2.8,1.25-2.8,2.8c0,1.55,1.25,2.8,2.8,2.8h0c1.53-.03,2.77-1.27,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_841",
    "data-name": "Path 841",
    className: "cls-6",
    d: "m296.09,247.52c0-1.16-.94-2.1-2.1-2.1-1.16,0-2.1.94-2.1,2.1s.94,2.1,2.1,2.1h0c1.13.03,2.07-.87,2.1-2,0-.03,0-.07,0-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    className: "cls-6",
    d: "m285.49,244.72c0-1.82-1.48-3.3-3.3-3.3s-3.3,1.48-3.3,3.3,1.48,3.3,3.3,3.3h0c1.82-.02,3.28-1.48,3.3-3.3Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_559",
    "data-name": "Group 559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    className: "cls-2",
    d: "m323.69,213.82c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-18.4-7-52.3-11.7-91-11.7s-75.4,5.1-93.2,12.6c-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.6,6.4,6.5,6.7,6.5,6.7v-37.3c0-3.5,2-6.9,5.3-7.9,1-.3,11.2-2.6,13.4,9.7,1,5.6-1.8,14.4,0,19.6,1.4,3.8,6.8,2,7.5.4,1.9-4.1-.9-11.6.6-18.2,1.6-6.6,10-5.9,11.3-1.3.7,2.8.8,12.4.8,19.6,0,4.5-1.5,6.4-2.8,11.7-1.5,6.1,2.2,9.2,4.5,9.4,2.6.2,6-3.2,5.2-7.9-.93-4.34-1.47-8.76-1.6-13.2,0-5.2.3-11.4,1.5-14.9,1.34-4.26,5.88-6.63,10.14-5.3.85.27,1.65.67,2.36,1.2,3.1,2.5,3.3,14.2,12.2,13.3s4.1-12.4,15-10.8c10,1.4,8.6,19.2,16.6,20.7,8,1.4,5-22.7,17.8-21.6,7.2.6,7.4,26,6.3,29.9s-2.2,11.3,3.7,10.8c4.8-.4,3.6-6.8,3-10.3-.6-3.9.3-18.3,1.4-22.9s7.7-4.4,9.1.3,4.3,45,4.2,47.4c-.3,6.4,10.1,5.4,7.7-.2-2.3-5.6-2.8-8.7-2.8-11.6,0-7,2.3-21.8,3-35,.3-6.7,6.8-12.7,11.8-9.5,5.9,3.8,4.6,25.5,4.6,25.5,0,0-3.6,14.1,1.6,15.4,7.6,1.8,5.9-9.3,4.5-14.4-1.4-5.2-.8-23.9,1.4-24.9,9.1-4.2,5.2,17.4,14.1,14.5,4.8-1.5,4.9-10.7,6.9-17.5,1.6-5.3,4.9-2.2,4.9-.6l.3,34c3.85-.42,6.62-3.89,6.2-7.73-.1-.9-.37-1.77-.8-2.57h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    className: "cls-7",
    d: "m313.59,156.12c0,12.3-44,22.2-98.2,22.2s-98.2-9.9-98.2-22.2,44-22.2,98.2-22.2c54.3.1,98.2,10,98.2,22.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    className: "cls-7",
    d: "m211.09,178.72c-43.6-.1-80-5.7-91.2-15.5-1.93-1.49-3.39-3.5-4.2-5.8-1-3.2-1.4-4.5-2.6-1.5-.28,1.28-.31,2.61-.1,3.9,2,14.3,43.3,21.5,96.9,20.2,5.8-.4,8.6-1.3,1.2-1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    className: "cls-7",
    d: "m108.99,215.62c-.1-.9-1.2-.4-1.3.2-.56,1.68-.22,3.53.9,4.9.6.8,2.8,1,2-1.1-.7-1.26-1.24-2.6-1.6-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_847",
    "data-name": "Path 847",
    className: "cls-7",
    d: "m135.39,188.22c-.54-3.1-2.13-5.93-4.5-8-5.5-4.6-11.4-3.9-17,.2-.7.5.1,1.1.9.6,7.7-4.9,16.2-.8,18.1,7.4,1.1,4.8-2.1,16.5,1,20.7.9,1.2,3.3-.2,1.9-3.4-2-4.8.7-12.4-.4-17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    className: "cls-7",
    d: "m152.99,221.82c-.1-.9-.8-1.4-1.4-.6-1.3,1.8-2.3,6.4.7,7.1.6.2,1.3-.6,1.4-1.2-.07-1.78-.3-3.56-.7-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    className: "cls-7",
    d: "m184.79,198.42c-5.8-1.5-5.7-8-10.6-10.7-2.9-1.7-5.9-1.7-9.3,0-.7.4-.6,1.1.2.8,2.87-1.05,6.08-.39,8.3,1.7,1.8,1.7,2.6,4.7,3.8,6.7,1.6,2.5,4.1,4.9,7.2,3.9,1.1-.3,1.9-2,.4-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_850",
    "data-name": "Path 850",
    className: "cls-7",
    d: "m144.99,184.62c-.5.2-.3,1.3.3,1.2,1.94-.37,3.93.19,5.4,1.5,1.18,1.36,2.03,2.96,2.5,4.7.4.9,1.7.4,1.8-.4.38-3.85-2.43-7.28-6.27-7.66-1.28-.13-2.57.1-3.73.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_851",
    "data-name": "Path 851",
    className: "cls-7",
    d: "m215.29,209.32c-1.2-.7-4.2-7.6-4.8-8.9-.79-1.92-1.76-3.76-2.9-5.5-1.65-2.76-4.84-4.19-8-3.6-.7.1-.5.6.4.6,8,.5,8.6,16.5,13.5,19.4,2.7,1.6,3.4-1.1,1.8-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_852",
    "data-name": "Path 852",
    className: "cls-7",
    d: "m233.89,190.82c-.8-.2-1.5.3-.6.6,3.14,1.43,5.38,4.3,6,7.7.3,1.3,2,1.2,1.9,0-.3-4.3-3.3-7.2-7.3-8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_853",
    "data-name": "Path 853",
    className: "cls-7",
    d: "m242.69,225.92c-.4-1.2-1.5-1.3-2.1-.3-.93,1.11-1.27,2.6-.9,4,.26,1.19,1.43,1.94,2.62,1.68.1-.02.19-.05.28-.08,1.1-.6.4-4.4.1-5.3Z"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_854",
    "data-name": "Path 854",
    className: "cls-5",
    d: "m138.89,124.62v26.9h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-26.9h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_855",
    "data-name": "Path 855",
    className: "cls-1",
    d: "m138.89,99.52v26.9h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-26.9h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_856",
    "data-name": "Path 856",
    className: "cls-7",
    d: "m138.89,77.52v24.8h0c.1,8.8,34.3,16,76.6,16s76.5-7.2,76.6-16h0v-24.8h-153.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_857",
    "data-name": "Path 857",
    className: "cls-2",
    d: "m138.89,77.52v47h1v-17.8c.03-.98.17-1.95.4-2.9.86-2.46,3.56-3.76,6.02-2.9.92.32,1.71.92,2.28,1.7,1.6,2.2,2,3.3,2.6,6.8.68,3.62.99,7.31.9,11-.3,2.2-2.9,8,1.1,8.9,3.5.8,3.1-4.8,2.5-8-.6-3.1,2.1-12.7,5.6-12.8,6.9-.1,5.5,12,8.6,12.7s5.6-11.4,10.8-11.2,5,5.6,11.6,6.1c4.6.3,6.5-9.5,13.5-4.1,4.8,3.8,8.4,18.6,7.5,22.7s-3.1,11.3,1.6,11.4c4.7.2,4.2-4.8,3.1-10.5-1.1-5.6.3-13,8-13.5,9.6-.6,10.5,20.3,9.5,25.3-.9,5,1.3,9.1,4.7,6.6s.2-5.1,0-7.5c-.3-3.1-1.3-32.2,5.9-31.9s5.2,8.4,12.7,7.5c4.9-.6,7.7-22.2,13.6-17.8s6.8,26.2,5.9,28.5c-.5,1.3-2.7,9.2,2,9.2,5,0,3.1-5.5,2-9.5-1.1-3.9,1.3-30.7,5-33.2,2.6-1.7,3.9.1,4.7,2.2v-24.3h-153.1v.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_858",
    "data-name": "Path 858",
    className: "cls-9",
    d: "m200.59,130.72c0-2.32-1.88-4.2-4.2-4.2s-4.2,1.88-4.2,4.2,1.88,4.2,4.2,4.2c2.31-.01,4.19-1.89,4.2-4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_859",
    "data-name": "Path 859",
    className: "cls-9",
    d: "m172.39,125.52c0-1.05-.85-1.9-1.9-1.9s-1.9.85-1.9,1.9c0,1.05.85,1.9,1.9,1.9h0c1.05,0,1.9-.85,1.9-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_860",
    "data-name": "Path 860",
    className: "cls-9",
    d: "m180.79,134.42c0-1.05-.85-1.9-1.9-1.9s-1.9.85-1.9,1.9c0,1.05.85,1.9,1.9,1.9h0c1.02.03,1.87-.76,1.9-1.78,0-.04,0-.08,0-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_861",
    "data-name": "Path 861",
    className: "cls-9",
    d: "m261.59,128.82c0-1.55-1.25-2.8-2.8-2.8-1.55,0-2.8,1.25-2.8,2.8s1.25,2.8,2.8,2.8h0c1.55,0,2.8-1.25,2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_862",
    "data-name": "Path 862",
    className: "cls-6",
    d: "m255.49,149.02c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.26-.01,2.29-1.04,2.3-2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_863",
    "data-name": "Path 863",
    className: "cls-6",
    d: "m277.09,154.12c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.25.02,2.28-.97,2.3-2.22,0-.03,0-.05,0-.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_864",
    "data-name": "Path 864",
    className: "cls-6",
    d: "m264.89,156.52c0-.77-.63-1.4-1.4-1.4-.77,0-1.4.63-1.4,1.4,0,.77.63,1.4,1.4,1.4h0c.77-.02,1.38-.63,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_865",
    "data-name": "Path 865",
    className: "cls-6",
    d: "m156.89,147.12c0-1.27-1.03-2.3-2.3-2.3-1.27,0-2.3,1.03-2.3,2.3s1.03,2.3,2.3,2.3h0c1.25.02,2.28-.98,2.3-2.23,0-.02,0-.05,0-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_866",
    "data-name": "Path 866",
    className: "cls-6",
    d: "m167.19,155.52c0-.77-.63-1.4-1.4-1.4-.77,0-1.4.63-1.4,1.4,0,.77.63,1.4,1.4,1.4h0c.72.05,1.35-.49,1.4-1.22,0-.06,0-.12,0-.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_867",
    "data-name": "Path 867",
    className: "cls-6",
    d: "m190.19,155.52c0-1.27-1.03-2.3-2.3-2.3s-2.3,1.03-2.3,2.3,1.03,2.3,2.3,2.3h0c1.21.06,2.24-.88,2.3-2.1,0-.07,0-.14,0-.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_561",
    "data-name": "Group 561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_868",
    "data-name": "Path 868",
    className: "cls-2",
    d: "m299.09,125.72c-.28-.95-.68-1.86-1.2-2.7-1.59-3.06-2.41-6.45-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-11.2-6.9-40.4-11.8-74.8-11.8s-64.6,5.1-75.3,12.1c-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c-.01,2.65-.66,5.26-1.9,7.6-.49.85-.77,1.82-.8,2.8,1.6,7.6,5.9,5,5.9,5v-19.5c.03-.98.16-1.95.4-2.9.86-2.46,3.56-3.76,6.02-2.9.92.32,1.71.92,2.28,1.7,1.6,2.2,2,3.3,2.6,6.8.68,3.62.99,7.31.9,11-.3,2.2-2.9,8,1.1,8.9,3.5.8,3.1-4.9,2.5-8s2.1-12.7,5.6-12.8c6.9-.1,5.5,12,8.6,12.7s5.6-11.4,10.8-11.2,5,5.6,11.6,6.1c4.6.3,6.5-9.5,13.5-4.1,4.8,3.8,8.4,18.6,7.5,22.7s-3.1,11.3,1.6,11.4c4.7.2,4.2-4.8,3.1-10.5-1.1-5.6.3-13,8-13.5,9.6-.6,10.5,20.3,9.5,25.3-.9,5,1.3,9.1,4.7,6.6s.2-5.1,0-7.5c-.3-3.1-1.3-32.2,5.9-31.9s5.2,8.4,12.7,7.5c4.9-.6,7.7-22.2,13.6-17.8s6.8,26.2,5.9,28.5c-.5,1.3-2.7,9.2,2,9.2,5,0,3.1-5.5,2-9.5-1.1-3.9,1.3-30.7,5-33.2,5-3.3,5.5,6.6,5.5,6.6v23.5s1.3,5.7,4.8,3.8c2.03-.9,3.06-3.18,2.4-5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_869",
    "data-name": "Path 869",
    className: "cls-7",
    d: "m216.29,92.12c-34.6-.1-64.3-5.4-72.2-12.8-1.29-1.03-2.18-2.48-2.5-4.1-.4-2.6-2.2-3.2-3.4-.5-.28.8-.41,1.65-.4,2.5.4,11.5,35.2,17,77.7,16,4.4-.3,6.6-1.1.8-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_870",
    "data-name": "Path 870",
    className: "cls-7",
    d: "m152.99,122.22c0-.7-.9-.7-1.3-.4-.92.54-1.22,1.72-.68,2.64.1.17.23.33.38.46.48.38,1.18.3,1.56-.19.16-.2.24-.45.24-.71-.02-.6-.08-1.21-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_871",
    "data-name": "Path 871",
    className: "cls-7",
    d: "m136.09,117.22c0-.7-.9-.7-1.3-.4-.92.54-1.22,1.72-.68,2.64.1.17.23.33.38.46.48.38,1.18.3,1.56-.19.16-.2.24-.45.24-.71-.12-.59-.19-1.2-.2-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    className: "cls-7",
    d: "m149.19,96.42c-3-1.9-7.6-2-9.7,1.2-.5.7.2.7.8.3,3.1-2.3,7.1-.9,9.2,1.9,2.03,2.96,3.01,6.52,2.8,10.1,0,1.1,1.1-1.8,1.1-3.8,0-3.7-.6-7.3-4.2-9.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_873",
    "data-name": "Path 873",
    className: "cls-7",
    d: "m167.39,107.02c-1.14-1.92-3.17-3.12-5.4-3.2-.5,0-.9.6-.3.8,2.7,1,3.5,2.1,4.6,4.3,1,2.2,1.2,4.2,2.1,6.9.4,1.1,1.7.5,1.7-1.1-.15-2.77-1.09-5.44-2.7-7.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_874",
    "data-name": "Path 874",
    className: "cls-7",
    d: "m190.39,110.82c-2.6-.2-4.6-3.7-6.1-4.6-1.51-.79-3.25-1-4.9-.6-.8.2-.5.7.4.6,1.4-.2,3.4,1.5,4.2,2.3.9.9,3.6,4.1,5.8,4.2,2.7.1,2.5-1.7.6-1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_875",
    "data-name": "Path 875",
    className: "cls-7",
    d: "m203.99,106.72c-.9-.1-1.5.3-.4.7,5.8,1.8,8.2,8.3,9.2,13.7.2,1.3.5.1.5-1,0-6.5-2.6-12.4-9.3-13.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_876",
    "data-name": "Path 876",
    className: "cls-7",
    d: "m215.09,137.12c0-.7-.9-.6-1.2-.2-.8,1.2-1.3,2.6-.5,3.8.37.55,1.12.7,1.68.32.37-.25.57-.68.52-1.12-.22-.92-.39-1.86-.5-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_877",
    "data-name": "Path 877",
    className: "cls-7",
    d: "m238.09,148.02c-.21-.46-.52-.87-.9-1.2-.4-.35-1.01-.31-1.36.09-.05.06-.1.13-.14.21-.49.79-.52,1.78-.1,2.6.6,1.9,3.4.8,2.5-1.7Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_878",
    "data-name": "Path 878",
    className: "cls-7",
    d: "m287.69,75.12c0,9-32.3,16.3-72.2,16.3s-72.2-7.3-72.2-16.3,32.3-16.3,72.2-16.3c39.9-.1,72.2,7.2,72.2,16.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_879",
    "data-name": "Path 879",
    className: "cls-2",
    d: "m112.99,154.42s1.4,4.5,5.2,6.1,5.9.5,7.3,1.6c1.4,1.2,6.8,3.3,6.8,3.3,3.6-.4.5,2.3,7.3,4.9,2.9,1.1,9.2.2,12,.9s9.9-1.2,11.7-.9c1.9.2,4,4.9,9.2,6.6,5.2,1.6,10.3-2.3,14.8-2.1,3.5.2,8-.2,11.7.2,3.8.5,7.3,3.9,12.2,3.7s18.7.7,21.3-.7,3.1-4.2,6.3-3.3c3.3.9,10.6,2.1,13.8,1.9,3.3-.2,8-3.5,10.1-2.8s16.2.9,19.9-.9c3.8-1.9,4.9-8.9,7.7-8.2s13.6,0,15.7-2.1,5.6-2.1,7.7-5.2c1.25-1.61.98-3.92-.6-5.2l-53.2,9-53,5.4-36.8-3.3-42-7.7-15.1-1.2Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_562",
    "data-name": "Group 562"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_880",
    "data-name": "Path 880",
    className: "cls-2",
    d: "m204.39,138.62c-.1,0-.1-.1-.2-.1q.1.1.2.1Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_564",
    "data-name": "Group 564"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_881",
    "data-name": "Path 881",
    className: "cls-14",
    d: "m213.89,41.52h-2.4v40.6h9.2v-40.6h-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_563",
    "data-name": "Group 563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_882",
    "data-name": "Path 882",
    className: "cls-2",
    d: "m211.49,77.62c2.91,1.41,6.01,2.39,9.2,2.9v-5.1c-3.19-.57-6.28-1.58-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_883",
    "data-name": "Path 883",
    className: "cls-14",
    d: "m211.49,72.32c2.9,1.46,6,2.47,9.2,3v-5.1c-3.2-.62-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_884",
    "data-name": "Path 884",
    className: "cls-14",
    d: "m211.49,82.12h9.2v-1.7c-3.19-.51-6.29-1.49-9.2-2.9v4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_885",
    "data-name": "Path 885",
    className: "cls-2",
    d: "m211.49,67.02c2.9,1.5,6,2.58,9.2,3.2v-5.1c-3.21-.7-6.3-1.85-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_886",
    "data-name": "Path 886",
    className: "cls-14",
    d: "m220.69,41.52h-7.1c2.24,1.24,4.63,2.22,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_887",
    "data-name": "Path 887",
    className: "cls-2",
    d: "m213.59,41.52h-2.1v4.1c2.87,1.74,5.97,3.09,9.2,4v-5.2c-2.47-.7-4.85-1.67-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_888",
    "data-name": "Path 888",
    className: "cls-14",
    d: "m211.49,51.02c2.88,1.67,5.98,2.95,9.2,3.8v-5.2c-3.25-.87-6.35-2.22-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_889",
    "data-name": "Path 889",
    className: "cls-14",
    d: "m211.49,61.62c2.9,1.55,5.99,2.7,9.2,3.4v-5.1c-3.23-.73-6.33-1.94-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_890",
    "data-name": "Path 890",
    className: "cls-2",
    d: "m211.49,56.32c2.89,1.62,5.98,2.83,9.2,3.6v-5.1c-3.24-.81-6.34-2.09-9.2-3.8v5.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m211.49,41.52c0,.3,2.1.6,4.6.6s4.6-.3,4.6-.6-2.1-.6-4.6-.6-4.6.3-4.6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m213.89,41.52c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3-2.2.1-2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m215.89,36.62l-.2,4.6c0,.22.18.4.4.4.22,0,.4-.18.4-.4h0l-.2-4.6c0-.16-.14-.29-.3-.3-.07.08-.11.19-.1.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_891",
    "data-name": "Path 891",
    className: "cls-14",
    d: "m182.29,32.72h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_565",
    "data-name": "Group 565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_892",
    "data-name": "Path 892",
    className: "cls-2",
    d: "m179.89,68.82c2.91,1.41,6.01,2.39,9.2,2.9v-5.1c-3.19-.57-6.28-1.58-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_893",
    "data-name": "Path 893",
    className: "cls-1",
    d: "m179.89,63.52c2.9,1.46,6,2.47,9.2,3v-5.1c-3.2-.62-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_894",
    "data-name": "Path 894",
    className: "cls-1",
    d: "m179.89,73.42h9.2v-1.7c-3.19-.51-6.29-1.49-9.2-2.9v4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_895",
    "data-name": "Path 895",
    className: "cls-2",
    d: "m179.89,58.22c2.9,1.5,6,2.58,9.2,3.2v-5.1c-3.21-.7-6.3-1.85-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_896",
    "data-name": "Path 896",
    className: "cls-1",
    d: "m189.09,32.72h-7.1c2.24,1.24,4.63,2.22,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_897",
    "data-name": "Path 897",
    className: "cls-2",
    d: "m181.99,32.72h-2.1v4.1c2.87,1.74,5.97,3.09,9.2,4v-5.2c-2.47-.68-4.86-1.66-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_898",
    "data-name": "Path 898",
    className: "cls-1",
    d: "m179.89,42.22c2.88,1.67,5.98,2.95,9.2,3.8v-5.2c-3.25-.87-6.35-2.22-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_899",
    "data-name": "Path 899",
    className: "cls-1",
    d: "m179.89,52.92c2.9,1.55,5.99,2.7,9.2,3.4v-5.1c-3.23-.73-6.33-1.94-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_900",
    "data-name": "Path 900",
    className: "cls-2",
    d: "m179.89,47.62c2.89,1.62,5.98,2.83,9.2,3.6v-5.1c-3.24-.81-6.34-2.09-9.2-3.8v5.3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 184.49,
    cy: 32.72,
    rx: 4.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m182.29,32.72c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3c-.74,0-1.49.09-2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m184.19,27.82l-.2,4.6c0,.22.18.4.4.4.22,0,.4-.18.4-.4h0s-.2-4.6-.2-4.6c0-.16-.14-.29-.3-.3,0,.1-.1.2-.1.3Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_568",
    "data-name": "Group 568"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_901",
    "data-name": "Path 901",
    className: "cls-14",
    d: "m248.59,32.72h-2.4v40.7h9.2v-40.7h-6.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_902",
    "data-name": "Path 902",
    className: "cls-2",
    d: "m246.19,68.82c2.91,1.41,6.01,2.39,9.2,2.9v-5.1c-3.19-.57-6.28-1.58-9.2-3v5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_903",
    "data-name": "Path 903",
    className: "cls-5",
    d: "m246.19,63.52c2.9,1.46,6,2.47,9.2,3v-5.1c-3.2-.62-6.3-1.7-9.2-3.2v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_904",
    "data-name": "Path 904",
    className: "cls-5",
    d: "m246.19,73.42h9.2v-1.7c-3.19-.51-6.29-1.49-9.2-2.9v4.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_905",
    "data-name": "Path 905",
    className: "cls-2",
    d: "m246.19,58.22c2.9,1.5,6,2.58,9.2,3.2v-5.1c-3.21-.7-6.3-1.85-9.2-3.4v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_906",
    "data-name": "Path 906",
    className: "cls-5",
    d: "m255.39,32.72h-7.1c2.24,1.24,4.63,2.22,7.1,2.9v-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_907",
    "data-name": "Path 907",
    className: "cls-2",
    d: "m248.29,32.72h-2.1v4.1c2.87,1.74,5.97,3.09,9.2,4v-5.2c-2.47-.68-4.86-1.66-7.1-2.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_908",
    "data-name": "Path 908",
    className: "cls-5",
    d: "m246.19,42.22c2.88,1.67,5.98,2.95,9.2,3.8v-5.2c-3.25-.87-6.35-2.22-9.2-4v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_909",
    "data-name": "Path 909",
    className: "cls-5",
    d: "m246.19,52.92c2.9,1.55,5.99,2.7,9.2,3.4v-5.1c-3.23-.73-6.33-1.94-9.2-3.6v5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    "data-name": "Path 910",
    className: "cls-2",
    d: "m246.19,47.62c2.89,1.62,5.98,2.83,9.2,3.6v-5.1c-3.24-.81-6.34-2.09-9.2-3.8v5.3Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 250.79,
    cy: 32.72,
    rx: 4.6,
    ry: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m248.59,32.72c0,.2,1,.3,2.2.3s2.2-.1,2.2-.3-1-.3-2.2-.3c-.74,0-1.48.1-2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m250.49,27.82l-.2,4.6c0,.22.18.4.4.4.22,0,.4-.18.4-.4h0l-.2-4.6c0-.16-.14-.29-.3-.3,0,.1-.1.2-.1.3Z"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576",
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_911",
    "data-name": "Path 911",
    className: "cls-11",
    d: "m323.69,213.82c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-4.7-1.76-9.51-3.2-14.4-4.3v-13.1c.4,1.3,1.8,4.9,4.6,3.3,2.03-1.06,3.03-3.4,2.4-5.6-.28-.95-.68-1.86-1.2-2.7-1.59-3.06-2.41-6.45-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-6.5-4-18.9-7.3-34.9-9.4v-28.3c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.2c-7.9-.7-16.5-1.2-25.5-1.3v-17.3h0c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v17.2c-7.8.1-15.4.4-22.5,1v-26.9c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.8c-18.5,2.1-32.9,5.8-39.7,10.2-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c-.01,2.65-.66,5.26-1.9,7.6-.49.85-.77,1.82-.8,2.8,1.6,7.3,5.6,5.2,5.9,5.1v17c-5.67,1.26-11.22,3-16.6,5.2-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.3,5.4,5.1,6.5,6.2,6.7v14.7h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-16.4c2.76-.26,5.09-2.15,5.9-4.8,1.1-1.2,1.2-3.7.1-5.6Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_575",
    "data-name": "Group 575",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_912",
    "data-name": "Path 912",
    d: "m323.69,213.82c-1.58-2.77-2.41-5.91-2.4-9.1,0,0,.4-24.1-.1-37.8-.3-8-2.2-16.6-14.8-21.6-4.7-1.76-9.51-3.2-14.4-4.3v-13.1c.4,1.3,1.8,4.9,4.6,3.3,2.03-1.06,3.03-3.4,2.4-5.6-.28-.95-.68-1.86-1.2-2.7-1.59-3.06-2.41-6.45-2.4-9.9l-.2-24.1h0v-5.5c-.1-3.8.6-9.2-4.9-13-6.5-4-18.9-7.3-34.9-9.4v-28.3c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.2c-7.9-.7-16.5-1.2-25.5-1.3v-17.3h0c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v17.2c-7.8.1-15.4.4-22.5,1v-26.9c0-.3-1.8-.6-4.2-.6l-.2-4.3c0-.17-.13-.3-.3-.3s-.3.13-.3.3h0l-.2,4.3c-2.3,0-4.2.3-4.2.6h0v27.8c-18.5,2.1-32.9,5.8-39.7,10.2-4.3,3.1-4.4,8.9-4.4,12.1v6.1h0l-.1,19.6c-.01,2.65-.66,5.26-1.9,7.6-.49.85-.77,1.82-.8,2.8,1.6,7.3,5.6,5.2,5.9,5.1v17c-5.67,1.26-11.22,3-16.6,5.2-11.1,5-12.5,13.5-12.5,16.9v39.1c0,4.2-1,8.35-2.9,12.1-.78,1.55-.95,3.33-.5,5,1.3,5.4,5.1,6.5,6.2,6.7v14.7h0c.1,11.9,46.1,21.5,102.9,21.5s102.8-9.6,102.9-21.5h0v-16.4c2.76-.26,5.09-2.15,5.9-4.8,1.1-1.2,1.2-3.7.1-5.6Z"
  }))))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 5.89,
    width: 430,
    height: 273
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoBookedCake);
export default __webpack_public_path__ + "static/media/NoBookedCake.595eddfd69ec9af517ea70a49d9e02d8.svg";
export { ForwardRef as ReactComponent };